<template>
  <div class="logo-black-and-white-content" id="identidade-visual-logo-preto-e-branco" data-search-anchor>
    <div class="title-black-and-white-wrapper">
      <h1 class="logo-black-and-white-span">{{ logoBlackAndWhiteTitleSpan }}</h1>
      <h1 class="logo-black-and-white-title">{{ logoBlackAndWhiteTitle }}</h1>
    </div>
    <div class="logo-black-and-white-description-wrapper">
      <IconCheck />
      <p class="logo-black-and-white-description">{{ logoBlackAndWhiteDescription }}</p>
    </div>
    <div class="logo-card-white">      
      <div
        class="logo-black-and-white-card-item"
        :style="{ backgroundImage: `url(${logoBlackAndWhiteImageSrc})` }"
      ></div>
    </div>    
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LogoBlackAndWhiteSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoBlackAndWhiteTitleSpan(): string {
    return this.getElementTitle(6, 0)
  }

  get logoBlackAndWhiteTitle(): string {
    return this.getElementText(6, 0)
  }

  get logoBlackAndWhiteDescription(): string {
    return this.getElementText(6, 1)
  }

  get logoBlackAndWhiteImageSrc(): string {
    return this.getElementMedia(6, 4)
  } 

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-black-and-white-content {
  display: grid;
  width: 100%;
  max-width: 1032px;
}

.title-black-and-white-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.logo-black-and-white-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-black-and-white-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.logo-black-and-white-description-wrapper {
  display: flex;
  align-items: center;  
}

.logo-card-white{
  margin: 0; 
  max-height: 731px;  
}

.logo-black-and-white-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
  width: 378px;  
  padding-left: 7px;
}

.logo-black-and-white-card-item {
  position: relative;  
  width: 100%;
  max-width: 1032px;
  height: 705px;
  border-radius: 8px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;  
}

</style>
